'use client'
import { useCallback } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'

export const useRedirectWithSearchParams = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const redirectWithParams = useCallback((newPathname: string) => {
    const params = new URLSearchParams()

    // Collect all params
    searchParams.forEach((value, key) => {
      params.set(key, value)
    })

    console.log('redirectWithParams | redirecting to: ', newPathname)

    // Push to new pathname with existing query
    router.push(`${newPathname}?${params.toString()}`)
  }, [router, searchParams])

  return redirectWithParams
}
